<template lang="pug">
#resize_heatmap
  template(v-if="$store.state.heatmap.show_resize_heatmap")
    vue-resizable(style="position:absolute", :height="iframe_height", :active="handlers", @resize:move="eHandler")
      .resizeable_block
      i.fas.fa-arrows-alt-v
      button.btn.btn-success.btn-sm.btn-fix-pageheight(@click="fixPageHeight")
        i.fas.fa-check.mr-2
        | 決定
</template>

<script>
import VueResizable from 'vue-resizable'
import Vue from 'vue'

export default {
  props: {
    height: Number,
    token: String
  },
  methods: {
    eHandler(data) {
      this.$store.commit( "heatmap/setPreviewPageHeight", data.height )
    },
    async fixPageHeight(e){
      await this.$store.dispatch( "heatmap/fixPageHeight" )
      location.href = `/users/heatmaps/${this.token}/edit_page_height?height=${this.$store.state.heatmap.preview_page_height}&device=${this.$store.state.heatmap.device}`
    }
  },
  data() {
    return {
      handlers: ["b"],
    }
  },
  async mounted(){
    await Vue.nextTick()
  },
  components: {
    VueResizable
  },
  computed: {
    iframe_height(){
      if(!this.$store.state.heatmap.page_height){
        return this.height;
      } else {
        return this.$store.state.heatmap.page_height + "px"
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
